import { useEffect, useRef } from 'react';

export const usePrevious = (prevStateValue: any) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = prevStateValue;
  });

  return ref.current;
};
